import React from 'react'
import { useConfirmDialog, useError, useMutation } from '@ztechapps/common.hook'
import { taskDocumentQueries } from '@ztechapps/task.common'

export const useDeleteTaskWithConfirm = () => {
  const { onError } = useError()
  const [deleteMutation] = useMutation(taskDocumentQueries.deleteConfig)
  const [deleting, setDeleting] = React.useState(false)

  const { onConfirm } = useConfirmDialog({
    text: 'Are you sure you want to delete this task?',
    title: 'Delete task?',
    buttons: { confirm: { text: 'Yes, delete it!' } },
    confirmed: async (taskId: string) => {
      try {
        setDeleting(true)
        await deleteMutation({ filter: { _id: taskId } })
      } catch (e) {
        onError(e)
      } finally {
        setDeleting(false)
      }
    },
  })

  return { onDelete: onConfirm, deleting }
}
